import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalItemSlider from './ModalItemSlider';
import { faCircle, faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import { Card, Col, Row } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useState } from 'react';
import VideoPlayerModal from './VideoPlayerModal';
import ContactBtn from './common/ContactBtn';
import { videoInfoLink } from '../data';
function ModelBuilder(){
    const [title, setTitle] = useState(null)
    const [videoLink, setVideoLink] = useState(null)
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const playVideo = (link, titleData) =>{
        handleShow()
        setVideoLink(link);
        setTitle(titleData)
    }
      
    return(
        <>
            <div className="max-width-set top-title-3">
                <div className='px-5 mx-5 '>
                    <h1 className='text-center top-title-0 py-1'>3D Builder</h1>
                </div>
                <p className="text-center">
                Sharing amazing 3D versions of your products starts with creating 3D models that are optimized to work seamlessly in all your channel applications.
                </p>

                <div className="player-feature p-4">
                    <p className="title-sub-sub  p-3 ">
                        Simply share your Product Asset Files and we do the rest. We use a combination of art and technology to quickly create 3D Models, Digital Twins, Synthetic Images and Large Format Renders.
                    </p>
                    <div className="modelBuidler-feature">
                        <Row>
                            <Col xs={{ span: 8, offset: 2 } }>
                                <Row>
                                    <Col md={{ span: 4}} className='py-2 my-1 inside-feature-modelbuilder'>
                                        <span><FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon mx-3'/></span>
                                        <b>Images</b>
                                    </Col>
                                    <Col md={{ span: 4}} className='py-2 my-1 inside-feature-modelbuilder'>
                                        <span><FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon mx-3'/></span>
                                        <b>Videos</b>
                                    </Col>
                                    <Col md={{ span: 4 }} className='py-2 my-1 inside-feature-modelbuilder'>
                                        <span><FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon mx-3'/></span>
                                        <b>CAD Files</b>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={{ span: 4}} className='py-2 my-1 inside-feature-modelbuilder'>
                                        <span><FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon mx-3'/></span>
                                        <b>Drawings</b>
                                    </Col>
                                    <Col md={{ span: 4}} className='py-2 my-1 inside-feature-modelbuilder'>
                                        <span><FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon mx-3'/></span>
                                        <b>Installed View</b>
                                    </Col>
                                    <Col md={{ span: 4}} className='py-2 my-1 inside-feature-modelbuilder'>
                                        <span><FontAwesomeIcon icon={faCircle} size='2xs' className='faw-icon mx-3'/></span>
                                        <b>Annotations</b>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>

            

            <div className="full-screen my-2">
                <ModalItemSlider />
            </div>
            {/* <WatchVideoBtn/> */}
            <ContactBtn />

            <Row className='d-flex justify-content-center max-width-set py-3 py-md-3 my-md-3'>
                <div className="bar-break d-flex justify-content-center align-content-center ">
                    <div className="mainBar">
                    </div>
                </div>
                <Col xs={12}>
                    <div className='px-md-5 mx-md-5 px-2 mx-2'>
                        <h1 className='text-center top-title-0 py-3 py-md-3 my-md-3'>Watch Videos</h1>
                    </div>
                </Col>
                <Carousel
                   additionalTransfrom={0}
                   arrows
                   autoPlaySpeed={3000}
                   centerMode={false}
                   className=" m-md-auto"
                   containerClass="container px-0"
                   dotListClass=""
                   draggable
                   focusOnSelect={false}
                   infinite={false}
                   itemClass="px-md-3"
                   keyBoardControl
                   minimumTouchDrag={80}
                   pauseOnHover
                   renderArrowsWhenDisabled={false}
                   renderButtonGroupOutside={false}
                   renderDotsOutside={false}
                   responsive={{
                     desktop: {
                       breakpoint: {
                         max: 3000,
                         min: 1024
                       },
                       items: 2,
                       partialVisibilityGutter: 40
                     },
                     mobile: {
                       breakpoint: {
                         max: 464,
                         min: 0
                       },
                       items: 1,
                       partialVisibilityGutter: 30
                     },
                     tablet: {
                       breakpoint: {
                         max: 1024,
                         min: 464
                       },
                       items: 2,
                       partialVisibilityGutter: 30
                     }
                   }}
                   rewind={false}
                   rewindWithAnimation={false}
                   rtl={false}
                   shouldResetAutoplay
                   showDots={false}
                   sliderClass="px-0"
                   slidesToSlide={1}
                   swipeable
                    >
                        {/* <Card className="annotation-sync-container border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/95n2uFJWwD8/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className=''>
                                <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('95n2uFJWwD8?si=KcokFwR0gIchzEBB', '3D Training and Marketing Platform')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/LdqJ2j77rTw/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className=''>
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot'  onClick={() => playVideo('LdqJ2j77rTw?si=ph3ArYxpbdnoEDaR', '3D Training Library for Natural Gas')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/hwjZZS7jHaU/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('hwjZZS7jHaU?si=Cm887MGniEVoddC8', 'Paracosma 3D Training Platform Feature Overview')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/MHwRNirYANs/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <img src="Image\t3.png" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('MHwRNirYANs?si=wcstGhhy1pVM3Z_L', 'What’s a 3D Model Worth?')} />
                            </Card.ImgOverlay>
                        </Card>

                        
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/kJoltPWS10I/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('kJoltPWS10I?si=_nGimEnX8rONezhZ', 'PowerView E-Learning Content: 3D Lessons, Quizzes & Gamification')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/VcqqIPP_y8s/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('VcqqIPP_y8s?si=bTGNrWS94oI4KAXJ', 'PowerView Camera Controls: No-Code Lesson Creation Tool')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/QfXqi97U-rI/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('QfXqi97U-rI?si=inFtND3ezuQHjqD-', 'PowerView Instructional Video: Bypass Meter Set')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/YjxUftV2qLA/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('YjxUftV2qLA?si=XUmFAz9iEXG3sinN', 'PowerView 3D UI Explorer: Service Line & Meter Set | Paracosma')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/hkOaJ7nvfx4/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('hkOaJ7nvfx4?si=pWingpSdRBdH0K_X', 'PowerView Training Library for Natural Gas - 3D Models Teaser | Paracosma')} />
                            </Card.ImgOverlay>
                        </Card>
                        <Card className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                            <img src="https://img.youtube.com/vi/_Uz2I7H5wGk/maxresdefault.jpg" alt="" className='img-thumbnail' />
                            <Card.ImgOverlay className='' >
                            <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo('_Uz2I7H5wGk?si=UeAMs7DAmI_LNZOI', 'PowerView Interactive Training Platform - Admin Tutorial | Paracosma')} />
                            </Card.ImgOverlay>
                        </Card> */}

                        {videoInfoLink?.map((item) =>(
                            <Card key={item.videiId} className="annotation-sync-container  border-0 rounded-0 p-3 h-auto">
                                <img src={`https://img.youtube.com/vi/${item.videiId}/maxresdefault.jpg`} alt="" className='img-thumbnail' />
                                <Card.ImgOverlay className='' >
                                <FontAwesomeIcon icon={faCirclePlay} size="xl" className='vid-btn-bot' onClick={() => playVideo(item.link, item.videoName)} />
                                </Card.ImgOverlay>
                            </Card>
                        ))}
                </Carousel>
            </Row>

            {videoLink && 
                <VideoPlayerModal title={title} link={videoLink} handleClose={handleClose} show={show} />
            }

        </>
    )
}


export default ModelBuilder;